<!-- Invalid zip panel -->
<div *ngIf="invalidZip" class="av-invalid-zip-panel">
    <div class="av-header av-header-warning">
        <i class="dx-icon-warning"></i>
        <span>Invalid postal code</span>
    </div>
    <p class="av-not-found-message">{{ invalidZipMessage }}</p>
    <div class="av-actions">
        <dx-button
            id="av-edit-zip"
            text="Edit Address"
            type="normal"
            stylingMode="contained"
            (onClick)="editAddress()">
        </dx-button>
    </div>
</div>

<div *ngIf="verifying" class="av-verifying">
    <i class="dx-icon-spinright av-spin"></i>
    <span>Verifying {{ label || 'address' }} with USPS…</span>
</div>

<!-- Suggestion panel -->
<div *ngIf="showSuggestion && suggestedAddress" class="av-suggestion-panel">
    <div class="av-header">
        <i class="dx-icon-check av-header-icon"></i>
        <span>USPS suggests corrections to your <strong>{{ label || 'address' }}</strong></span>
    </div>
    <div class="av-comparison">
        <div class="av-col">
            <div class="av-col-label">Your address</div>
            <div class="av-field" [class.av-changed]="fieldsDiffer('line_1')">
                <span class="av-label">Address</span>
                <span class="av-value">{{ address.line_1 }}</span>
            </div>
            <div class="av-field" *ngIf="address.line_2" [class.av-changed]="fieldsDiffer('line_2')">
                <span class="av-label">Line 2</span>
                <span class="av-value">{{ address.line_2 }}</span>
            </div>
            <div class="av-field" [class.av-changed]="fieldsDiffer('city')">
                <span class="av-label">City</span>
                <span class="av-value">{{ address.city }}</span>
            </div>
            <div class="av-field" [class.av-changed]="fieldsDiffer('postal_code')">
                <span class="av-label">Postal Code</span>
                <span class="av-value">{{ address.postal_code }}</span>
            </div>
        </div>
        <div class="av-arrow">
            <i class="dx-icon-arrowright"></i>
        </div>
        <div class="av-col av-col-suggested">
            <div class="av-col-label">Suggested</div>
            <div class="av-field" [class.av-changed]="fieldsDiffer('line_1')">
                <span class="av-label">Address</span>
                <span class="av-value">{{ suggestedAddress.line_1 }}</span>
            </div>
            <div class="av-field" *ngIf="suggestedAddress.line_2 || address.line_2" [class.av-changed]="fieldsDiffer('line_2')">
                <span class="av-label">Line 2</span>
                <span class="av-value">{{ suggestedAddress.line_2 }}</span>
            </div>
            <div class="av-field" [class.av-changed]="fieldsDiffer('city')">
                <span class="av-label">City</span>
                <span class="av-value">{{ suggestedAddress.city }}</span>
            </div>
            <div class="av-field" [class.av-changed]="fieldsDiffer('postal_code')">
                <span class="av-label">Postal Code</span>
                <span class="av-value">{{ suggestedAddress.postal_code }}</span>
            </div>
        </div>
    </div>
    <div class="av-actions">
        <dx-button
            id="av-accept-suggestion"
            text="Accept Suggestion"
            type="default"
            stylingMode="contained"
            (onClick)="acceptSuggestion()"
            class="mr-2">
        </dx-button>
        <dx-button
            id="av-keep-original"
            text="Keep Original"
            type="normal"
            stylingMode="outlined"
            (onClick)="keepOriginal()">
        </dx-button>
    </div>
</div>

<!-- Not found panel -->
<div *ngIf="addressNotFound" class="av-not-found-panel">
    <div class="av-header av-header-warning">
        <i class="dx-icon-warning"></i>
        <span>{{ label || 'Address' }} could not be verified</span>
    </div>
    <p class="av-not-found-message">{{ addressNotFoundMessage }}</p>
    <p class="av-not-found-hint">You can save anyway if you are confident in this address, or go back to correct it.</p>
    <div class="av-actions">
        <dx-button
            id="av-save-anyway"
            text="Save Anyway"
            type="danger"
            stylingMode="outlined"
            (onClick)="saveAnyway()"
            class="mr-2">
        </dx-button>
        <dx-button
            id="av-edit-address"
            text="Edit Address"
            type="normal"
            stylingMode="contained"
            (onClick)="editAddress()">
        </dx-button>
    </div>
</div>
